<template>
  <time class="relative-time font-mono" :datetime="absolute" :title="absolute">{{ relative }}</time>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useRelativeTime } from '@/composables/useRelativeTime';

const props = defineProps<{
  timestamp: string | Date | null | undefined;
}>();

const { relative, absolute } = useRelativeTime(toRef(props, 'timestamp'));
</script>

<style scoped lang="scss">
.relative-time {
  color: var(--stone);
  font-size: var(--fs-mono);
  letter-spacing: 0.01em;
}
</style>
